import React, { useState, useEffect } from 'react';
import AladdinHint from '../../../../components/AladdinHint/AladdinHint';
import { updateAccessHotTopicMissionVariableApi } from '../../../../store/userMission/api';
import AppContentContainer from '../../../../components/AppContentContainer/AppContentContainer.js';
import { tracking } from '../../../../utils/tracking';
import HotTopicContentSlides from './HotTopicContentSlidesNew';
import { getLazyPackStatistics } from '../../../../store/event/api';

const HotTopicView: React.FC<any> = props => {
  const { intl, history, hotTopic, renderHeaderButton } = props;
  const [statistics, setStatistics] = useState<any>({});
  const [contents, setContents] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      setContents(hotTopic);
    };

    fetchData()
      .then()
      .catch();
  }, [hotTopic]);

  useEffect(() => {
    renderHeaderButton(false);
  }, [renderHeaderButton]);

  useEffect(() => {
    tracking('Adviser enter hot topic');
    updateAccessHotTopicMissionVariableApi();
  }, []);

  useEffect(() => {
    const getStatistics = async () => {
      const data = await getLazyPackStatistics();
      setStatistics(data);
    };
    getStatistics()
      .then()
      .catch(console.log);
  }, []);

  const handleModeChange = (mode: string) => {
    if (mode === 'studio') {
      tracking('Click on Hot Topic - Enter Studio');
      // Replace (not push) so the back button returns to the real previous page
      // instead of stepping back through the existing/studio mode toggle.
      history.replace('/hot_topic_studio');
    }
  };

  return (
    <AppContentContainer>
      <div>
        <div style={{ padding: '8px 0' }}>
          <AladdinHint
            containerProps={{ justify: 'center' }}
            title={intl.formatMessage({ id: 'aladdin-hot-topic-title' })}
            helpCenter="c92"
          />
          <HotTopicContentSlides
            {...props}
            hotTopic={contents}
            eventType="hot topic"
            statistics={statistics}
            categoryViewPath="/hot_topic_category"
            tagViewPath="/hot_topic_tag"
            enableLanguages={true}
            mode="existing"
            onModeChange={handleModeChange}
            HotTopicItemProps={{
              enableLanguages: true
            }}
          />
        </div>
      </div>
    </AppContentContainer>
  );
};

export default HotTopicView;
